<script>
import RelatorioLancamentosPagamentos from './RelatorioLancamentosPagamentos.vue';
import RelatorioLancamentosRubricaSintetico from './RelatorioLancamentosRubricaSintetico.vue';
import RelatorioComprasLicitacoes from './RelatorioComprasLicitacoes.vue';
import transparenciaServico from '../../servico';
import Carregando from '~componentes/Carregando.vue';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { datepicker } from 'vue-strap';

export default {
  name: 'RelatoriosProjeto',
  components: { RelatorioLancamentosPagamentos, RelatorioLancamentosRubricaSintetico, RelatorioComprasLicitacoes, Carregando, datepicker },
  data() {
    return {
      projeto: {
        idProjeto: null,
        nomeProjeto: null,
      },
      tipoRelatorio: null,
      relatorio: null,
      relatorioFiltrado: null,
      carregando: true,
      semResultado: false,
      RELATORIO_LANCAMENTOS: '0',
      RELATORIO_PAGAMENTO_PESSOA_FISICA: '1',
      RELATORIO_PAGAMENTO_PESSOA_JURIDICA: '2',
      RELATORIO_PAGAMENTO_AGENTE: '3',
      RELATORIO_PAGAMENTO_ALUNO: '4',
      RELATORIO_PAGAMENTO_CLT: '5',
      RELATORIO_RUBRICAS: '6',
      RELATORIO_COMPRAS_LICITACOES: '7',
      tituloRelatorio: '',
      isRelatorioRubrica: false,
      isRelatorioComprasLicitacoes: false,
      dataInicio: '',
      dataFim: '',
    }
  },
  methods: {
    carregarProjeto(id) {
      return transparenciaServico
        .informacaoProjeto(id)
        .then(informacaoProjeto => {
          this.projeto = informacaoProjeto;
        });
    },
    gerarRelatorioLancamentos() {
      this.relatorio = null;

      return transparenciaServico.relatorioLancamentos(this.$route.params.id)
        .then(relatorio => {
          this.carregando = false;

          if (relatorio.length === 0) {
            this.exibirMensagemRelatorioVazio();
            this.semResultado = true;
          } else {
            this.relatorio = relatorio;
          }
        })
        .catch(() => {
          this.$swal('', 'Ocorreu um erro ao exibir o relatório, tente novamente.', 'error');
        });
    },
    gerarRelatorioRubricas() {
      this.relatorio = null;

      return transparenciaServico.relatorioRubricas(this.$route.params.id)
        .then(resultado => {
          this.carregando = false;
          let relatorio = resultado.groupBy('metaEtapa');

          relatorio = Object.keys(relatorio).map((chave, indice) => {
            return relatorio[chave].groupBy('nomeRubrica');
          });

          if (resultado.length === 0) {
            this.exibirMensagemRelatorioVazio();
            this.semResultado = true;
          } else {
            this.relatorio = relatorio;
          }
        })
        .catch(() => {
          this.$swal('', 'Ocorreu um erro ao exibir o relatório, tente novamente.', 'error');
        });
    },
    gerarRelatorioComprasLicitacoes() {
      this.relatorio = null;

      return transparenciaServico.relatorioComprasLicitacoes(this.$route.params.id)
        .then(relatorio => {
          this.carregando = false;

          if (relatorio.length === 0) {
            this.exibirMensagemRelatorioVazio();
            this.semResultado = true;
          } else {
            this.relatorio = relatorio;
          }
        })
        .catch(() => {
          this.$swal('', 'Ocorreu um erro ao exibir o relatório, tente novamente.', 'error');
        });
    },
    gerarRelatorioPagamentoPessoaFisica() {
      this.relatorio = null;

      return transparenciaServico.relatorioPagamentoPessoaFisica(this.$route.params.id)
        .then(relatorio => {
          this.carregando = false;

          if (relatorio.length === 0) {
            this.exibirMensagemRelatorioVazio();
            this.semResultado = true;
          } else {
            this.relatorio = relatorio;
          }
        })
        .catch(() => {
          this.$swal('', 'Ocorreu um erro ao exibir o relatório, tente novamente.', 'error');
        });
    },
    gerarRelatorioPagamentoPessoaJuridica() {
      this.relatorio = null;

      return transparenciaServico.relatorioPagamentoPessoaJuridica(this.$route.params.id)
        .then(relatorio => {
          this.carregando = false;


          if (relatorio.length === 0) {
            this.exibirMensagemRelatorioVazio();
            this.semResultado = true;
          } else {
            this.relatorio = relatorio;
          }
        })
        .catch(() => {
          this.$swal('', 'Ocorreu um erro ao exibir o relatório, tente novamente.', 'error');
        });
    },
    gerarRelatorioPagamentoAgente() {
      this.relatorio = null;

      return transparenciaServico.relatorioPagamentoAgente(this.$route.params.id)
        .then(relatorio => {
          this.carregando = false;

          if (relatorio.length === 0) {
            this.exibirMensagemRelatorioVazio();
            this.semResultado = true;
          } else {
            this.relatorio = relatorio;
          }
        })
        .catch(() => {
          this.$swal('', 'Ocorreu um erro ao exibir o relatório, tente novamente.', 'error');
        });
    },
    gerarRelatorioPagamentoAluno() {
      this.relatorio = null;

      return transparenciaServico.relatorioPagamentoAluno(this.$route.params.id)
        .then(relatorio => {
          this.carregando = false;

          if (relatorio.length === 0) {
            this.exibirMensagemRelatorioVazio();
            this.semResultado = true;
          } else {
            this.relatorio = relatorio;
          }
        })
        .catch(() => {
          this.$swal('', 'Ocorreu um erro ao exibir o relatório, tente novamente.', 'error');
        });
    },
    gerarRelatorioPagamentoClt() {
      this.relatorio = null;

      return transparenciaServico.relatorioPagamentoClt(this.$route.params.id)
        .then(relatorio => {
          this.carregando = false;

          if (relatorio.length === 0) {
            this.exibirMensagemRelatorioVazio();
            this.semResultado = true;
          } else {
            this.relatorio = relatorio;
          }
        })
        .catch(() => {
          this.$swal('', 'Ocorreu um erro ao exibir o relatório, tente novamente.', 'error');
        });
    },
    exibirMensagemRelatorioVazio() {
      this.$swal('', 'Nenhum resultado encontrado.', 'info');
    },
    mostrarRelatorioRubricas() {
      this.isRelatorioRubrica = this.tipoRelatorio === this.RELATORIO_RUBRICAS;
    },
    mostrarRelatorioComprasLicitacoes() {
      this.isRelatorioComprasLicitacoes = this.tipoRelatorio === this.RELATORIO_COMPRAS_LICITACOES;
    },
    voltar() {
      this.$router.push({ name: 'transparencia.projetos.detalhar', query: this.$route.query, params: { id: this.$route.params.id } });
    },
    filtrar() {
      if (this.relatorio && this.relatorio.length > 0) {  
        if (!this.dataInicio && !this.dataFim) {
          this.relatorioFiltrado = this.relatorio
          return;
        }
        this.carregando = true;
        this.relatorioFiltrado = this.relatorio.filter((relatorio) => {
          let dataRelatorioFormatada = this.$options.filters.formatarData(relatorio.data)
          let dataRelatorio = moment(dataRelatorioFormatada, 'DD/MM/YYYY');

          let dentroDoIntervalo = true;
        
          if (this.dataInicio) {
            let dataVigenciaInicio = moment(this.dataInicio, 'DD/MM/YYYY');
            dentroDoIntervalo = dentroDoIntervalo && dataRelatorio.isSameOrAfter(dataVigenciaInicio);
          }
          
          if (this.dataFim) {
            let dataVigenciaFim = moment(this.dataFim, 'DD/MM/YYYY');
            dentroDoIntervalo = dentroDoIntervalo && dataRelatorio.isSameOrBefore(dataVigenciaFim);
          }

          return dentroDoIntervalo;
        })
        
        this.carregando = false;

      } else {
        this.$swal('', 'Não há relatórios para serem filtrados', 'error');
      }
    },
    limparFiltros() {
      this.dataInicio = '';
      this.dataFim = '';
      this.relatorioFiltrado = this.relatorio;
    },
    imprimirPagina() {
      window.print();
    },
    formatarNumero(valor) {
      return this.$options.filters.formatarNumero(valor);
    },
    formatarNomeArquivo(titulo) {
      return titulo
        .replace(/Relatório de\s*/i, "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/\s+/g, "_")
        .slice(0, 31);
    },
    exportarExcel() {
      const data = [
        [this.tituloRelatorio],
        [],
        ["Projeto: ", this.projeto.nomeProjeto],
        [],
        ["Data", "CPF/CNPJ", "Rubrica", "Histórico", "Complemento", "Documento", "Valor (R$)"],
      ];

      this.relatorioFiltrado.forEach(item => {
        data.push([
          this.$options.filters.formatarData(item.data),
          item.cpfCnpj,
          item.nomeRubrica || '---',
          item.historico,
          item.complemento,
          item.documento || '---',
          item.creditoDebito === 1 ? (this.formatarNumero(item.valor)) : (this.formatarNumero(-item.valor)),
        ]);
      });

      const ws = XLSX.utils.aoa_to_sheet(data);

      const nomeArquivo = this.formatarNomeArquivo(this.tituloRelatorio);

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, nomeArquivo);

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${nomeArquivo}.xlsx`);
    },
    exportarExcelComprasLicitacoes() {
      const data = [
        [this.tituloRelatorio],
        [],
        ["Projeto: ", this.projeto.nomeProjeto],
        [],
        ["Data", "Compra/Licitação", "Pedido", "CNPJ fornecedor", "Razão social fornecedor", "Valor total pedido (R$)"],
      ];

      this.relatorioFiltrado.forEach(item => {
        data.push([
          this.$options.filters.formatarData(item.data),
          item.solicitacaoCompra + " - " + item.compraLicitacao,
          item.numeroPedidoCompra,
          item.cpfcnpj,
          item.nomePessoaFisicaJuridica,
          this.formatarNumero(item.valor),
        ]);
      });

      const ws = XLSX.utils.aoa_to_sheet(data);

      const nomeArquivo = "compras_licitações";

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, nomeArquivo);

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${nomeArquivo}.xlsx`);
    },
    exportarExcelRubrica() {
      const data = [
        [this.tituloRelatorio],
        [],
        ["Projeto: ", this.projeto.nomeProjeto],
        [],
        ["Rubrica", "Valor total", "Repassado", "Provisão", "A pagar", "A receber", "Lançado (+/-)", "Saldo (=)"],
      ];

      let rubricaTotal = 0;
      let repassadoTotal = 0;
      let provisaoTotal = 0;
      let aPagarTotal = 0;
      let aReceberTotal = 0;
      let lancamentoTotal = 0;
      let saldoTotal = 0;

      const dadosRubricas = Object.keys(this.relatorio[0]);
      for (const itemRubrica of dadosRubricas) {
        data.push([
          itemRubrica,
          this.projeto.utilizarDefinicaoSubrubrica ? "" : this.formatarNumero(this.relatorio[0][itemRubrica][0].valorTotalRubrica),
          this.projeto.utilizarDefinicaoSubrubrica ? "" : this.formatarNumero(this.relatorio[0][itemRubrica][0].valorRubrica)
        ]);

        let saldoParcial = 0;

        const dadosLancamentos = this.relatorio[0][itemRubrica];
        for (const itemSubrubrica of dadosLancamentos) {
          saldoParcial = saldoParcial + itemSubrubrica.valorSubrubrica - itemSubrubrica.valorProvisao + itemSubrubrica.valorLancado - itemSubrubrica.valorPagar;
          data.push([
            "  " + itemSubrubrica.nomeSubrubrica,
            this.projeto.utilizarDefinicaoSubrubrica ? this.formatarNumero(itemSubrubrica.valorTotalSubrubrica) : "",
            this.projeto.utilizarDefinicaoSubrubrica ? this.formatarNumero(itemSubrubrica.valorSubrubrica) : "",
            this.formatarNumero(itemSubrubrica.valorProvisao),
            this.formatarNumero(itemSubrubrica.valorPagar),
            this.formatarNumero(itemSubrubrica.valorReceber),
            this.formatarNumero(itemSubrubrica.valorLancado + itemSubrubrica.valorGastoRubrica),
            this.projeto.utilizarDefinicaoSubrubrica ? this.formatarNumero(saldoParcial) : ""
          ]);
        }

        const valorRubrica = dadosLancamentos.reduce((totalItem, item) => totalItem + item.valorTotalSubrubrica, 0);
        const valorRepassado = dadosLancamentos.reduce((totalItem, item) => totalItem + item.valorSubrubrica, 0);
        const valorProvisao = dadosLancamentos.reduce((totalItem, item) => totalItem + item.valorProvisao, 0);
        const valorAPagar = dadosLancamentos.reduce((totalItem, item) => totalItem + item.valorPagar, 0);
        const valorAReceber = dadosLancamentos.reduce((totalItem, item) => totalItem + item.valorReceber, 0);
        const valorLancamento = dadosLancamentos.reduce((totalItem, item) => totalItem + item.valorLancado + item.valorGastoRubrica, 0);

        data.push([
          "TOTAL",
          this.projeto.utilizarDefinicaoSubrubrica ? this.formatarNumero(valorRubrica) : "",
          this.projeto.utilizarDefinicaoSubrubrica ? this.formatarNumero(valorRepassado) : "",
          this.formatarNumero(valorProvisao),
          this.formatarNumero(valorAPagar),
          this.formatarNumero(valorAReceber),
          this.formatarNumero(valorLancamento),
          this.formatarNumero(saldoParcial)
        ])
        data.push([]);

        rubricaTotal = rubricaTotal + valorRubrica;
        repassadoTotal = repassadoTotal + valorRepassado;
        provisaoTotal = provisaoTotal + valorProvisao;
        aPagarTotal = aPagarTotal + valorAPagar;
        aReceberTotal = aReceberTotal + valorAReceber;
        lancamentoTotal = lancamentoTotal + valorLancamento;
        saldoTotal = saldoTotal + saldoParcial;
      }

      data.push([
        "Total para o projeto",
        this.projeto.utilizarDefinicaoSubrubrica ? this.formatarNumero(rubricaTotal) : "",
        this.projeto.utilizarDefinicaoSubrubrica ? this.formatarNumero(repassadoTotal) : "",
        this.formatarNumero(provisaoTotal),
        this.formatarNumero(aPagarTotal),
        this.formatarNumero(aReceberTotal),
        this.formatarNumero(lancamentoTotal),
        this.formatarNumero(saldoTotal)
      ])

      const ws = XLSX.utils.aoa_to_sheet(data);

      const nomeArquivo = this.formatarNomeArquivo(this.tituloRelatorio);

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, nomeArquivo);

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${nomeArquivo}.xlsx`);
    },
    gerarRelatorio() {
      switch (this.tipoRelatorio) {
        case (this.RELATORIO_LANCAMENTOS):
          this.tituloRelatorio = 'Relatório de lançamentos financeiros';
          this.gerarRelatorioLancamentos();
          break;

        case (this.RELATORIO_PAGAMENTO_PESSOA_FISICA):
          this.tituloRelatorio = 'Relatório de pagamento pessoa física';
          this.gerarRelatorioPagamentoPessoaFisica();
          break;

        case (this.RELATORIO_PAGAMENTO_PESSOA_JURIDICA):
          this.tituloRelatorio = 'Relatório de pagamento pessoa jurídica';
          this.gerarRelatorioPagamentoPessoaJuridica();
          break;

        case (this.RELATORIO_PAGAMENTO_AGENTE):
          this.tituloRelatorio = 'Relatório de pagamento a agentes ou servidores públicos';
          this.gerarRelatorioPagamentoAgente();
          break;
        case (this.RELATORIO_PAGAMENTO_CLT):
          this.tituloRelatorio = 'Relatório de pagamento pessoa física CLT';
          this.gerarRelatorioPagamentoClt();
          break;

        case (this.RELATORIO_RUBRICAS):
          this.tituloRelatorio = 'Relatório de rubricas';
          this.gerarRelatorioRubricas();
          break;

        case (this.RELATORIO_COMPRAS_LICITACOES):
          this.tituloRelatorio = 'Relatório de compras/licitações';
          this.gerarRelatorioComprasLicitacoes();
          break;

        default:
          this.tituloRelatorio = 'Relatório de pagamento a alunos';
          this.gerarRelatorioPagamentoAluno();
          break;
      }
    },
  },
  watch: {
    $route(to, from) {
      if (to.name === 'transparencia.projetos.detalhar.lancamento') {
        this.tipoRelatorio = to.params.idTipoRelatorio;
        this.semResultado = false;
        this.carregando = true;
        this.mostrarRelatorioRubricas();
        this.mostrarRelatorioComprasLicitacoes();
        this.carregarProjeto(to.params.id);
        this.gerarRelatorio();
      }
    },
    relatorio() {
      this.relatorioFiltrado = this.relatorio;
    },
  },
  mounted() {
    this.tipoRelatorio = this.$route.params.idTipoRelatorio;
    this.mostrarRelatorioRubricas();
    this.mostrarRelatorioComprasLicitacoes();
    this.carregarProjeto(this.$route.params.id);
    this.gerarRelatorio()
    this.$root.tituloDaPagina = `Portal da transparência`;
  },
}
</script>

<template>
  <div>

    <div class="row hidden-print" style="padding-left:20px">
      <div class="col-md-12 flex-container" style="justify-content:start; padding-left:15px">
        <h2><b>{{ tituloRelatorio }}</b></h2>
      </div>
    </div>

    <div class="row hidden-print" style="padding-left:20px">

      <div class="col-md-10 flex-container" style="justify-content:start; padding-left:15px">
        <h3><b>Projeto: {{ projeto.nomeProjeto }}</b></h3>
      </div>

      <div class="col-md-2 flex-container" style="justify-content:end; gap:10px">

        <button class="btn btn-primary" @click="exportarExcel" v-if="!isRelatorioRubrica && !isRelatorioComprasLicitacoes">
          <i class="fa fa-file-excel-o"></i> Excel
        </button>

        <button class="btn btn-primary" @click="exportarExcelRubrica" v-if="isRelatorioRubrica">
          <i class="fa fa-file-excel-o"></i> Excel
        </button>

        <button class="btn btn-primary" @click="exportarExcelComprasLicitacoes" v-if="isRelatorioComprasLicitacoes">
          <i class="fa fa-file-excel-o"></i> Excel
        </button>

        <button class="btn btn-primary" @click="imprimirPagina">
          <i class="fa fa-file-pdf-o"></i> PDF
        </button>

        <button class="btn btn-primary" @click="voltar">
          <i class="fa fa-arrow-left"></i> Voltar
        </button>

      </div>

    </div>

    <div v-if="isRelatorioRubrica" style="margin-bottom: 20px"></div>

    <div class="row hidden-print" style="padding-left:20px; margin-bottom: 20px;" v-if="!isRelatorioRubrica">
      <div class="col-xs-12">
        <label class="control-label">Periodo de pagamento</label>
      </div>

      <div class="col-xs-2" style="padding-right: 0px;">
        <div class="form-group">
          <label class="control-label">De:</label>

          <datepicker v-model="dataInicio" format="dd/MM/yyyy" placeholder="  /  /     " lang="pt-BR"
            data-vv-name="dataInicio" data-vv-as="data inicial" v-validate="'date_format:dd/MM/yyyy'"></datepicker>
        </div>
      </div>

      <div class="col-xs-2">
        <div class="form-group">
          <label class="control-label">Até:</label>

          <datepicker v-model="dataFim" format="dd/MM/yyyy" placeholder="  /  /     " lang="pt-BR"
            data-vv-name="dataFim" data-vv-as="data fim" v-validate="'date_format:dd/MM/yyyy'"></datepicker>
        </div>
      </div>

      <div class="col-xs-3">

        <label class="control-label" style="visibility: hidden; margin-bottom: 5px;">filtrar</label>

        <div class="row">
          <button class="btn btn-primary" style="margin-right: 5px;" @click="filtrar">
            Filtrar
          </button>

          <button class="btn btn-primary" @click="limparFiltros" :disabled="!dataInicio && !dataFim">
            Limpar Filtros
          </button>
        </div>

      </div>

    </div>

    <div class="col-xs-12" v-if="semResultado">
      <div class="ibox float-e-margins">
        <div class="ibox-content">
          <p class="text-center">
            Nenhum resultado encontrado.
          </p>
        </div>
      </div>
    </div>

    <Carregando v-if="carregando"></Carregando>

    <div class="row " id="relatorio" v-if="!carregando && relatorio !== null">
      <div class="col-xs-12">

        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <relatorio-lancamentos-pagamentos :dados="relatorioFiltrado" :projeto="projeto" :titulo="tituloRelatorio"
              v-if="!isRelatorioRubrica && !isRelatorioComprasLicitacoes">
            </relatorio-lancamentos-pagamentos>

            <relatorio-lancamentos-rubrica-sintetico :relatorio="relatorio" :projeto="projeto" v-if="isRelatorioRubrica">
            </relatorio-lancamentos-rubrica-sintetico>

            <relatorio-compras-licitacoes :dados="relatorioFiltrado" :projeto="projeto" :titulo="tituloRelatorio"
              v-if="isRelatorioComprasLicitacoes">
            </relatorio-compras-licitacoes>

          </div>
        </div>

      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/transparencia/componentes/compartilhado/RelatoriosProjeto.vue